import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { transformFileSize } from '@mining/ui/core/util';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzUploadFile } from 'ng-zorro-antd/upload';
@Component({
  selector: 'm-upload-file',
  exportAs: 'mUploadFile',
  template: `
    <div class="m-upload-container" [ngStyle]="{ height: !fileList.length ? '' : '65%' }">
      <m-upload-meta
        *ngIf="!fileList.length"
        [mMultiple]="mMultiple"
        [mBeforeUpload]="beforeUpload"
        [mFileTypeTip]="mFileTypeTip"
        [mAcceptFileType]="mAcceptFileType"
        [mTipText]="mTipText"
      ></m-upload-meta>
      <m-upload-file-list
        *ngIf="mMultiple; else mSingleFile"
        [(mFileList)]="fileList"
        (mFileListChange)="fileListChange($event)"
        [mFooterRef]="fileListFooter"
      ></m-upload-file-list>
      <ng-template #fileListFooter>
        <div class="m-upload-file-list-footer">
          <span>共 {{ fileList.length }} 条数据</span>
          <nz-upload *ngIf="mMultiple" [nzMultiple]="mMultiple" [nzBeforeUpload]="beforeUpload" [nzAccept]="mAcceptFileType">
            <button nz-button nzType="default" class="btn-add">
              <i nz-icon nzType="plus-circle" nzTheme="outline"></i>
              继续添加
            </button>
          </nz-upload>
          <button *ngIf="mShowFooterBtn && mBtnDesc !== ''" nz-button nzType="primary" (click)="onCreateTask()">{{ mBtnDesc }}</button>
        </div>
      </ng-template>
      <ng-template #mSingleFile>
        <m-upload-single-file
          [(mFileList)]="fileList"
          (mFileListChange)="fileListChange($event)"
          [mSingFileIcon]="mSingFileIcon"
          [mAcceptFileType]="mAcceptFileType"
          [mBtnDesc]="mBtnDesc"
          [mShowFooterBtn]="mShowFooterBtn"
          (mCreateTask)="onCreateTask()"
        ></m-upload-single-file>
      </ng-template>
    </div>
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MUploadFileComponent {
  @Input() mBtnDesc = '';
  @Input() mAcceptFileType = '';
  @Input() mFileTypeTip = '';
  @Input() mTipText = '';
  @Input() mMultiple = true;
  @Input() mShowFooterBtn = true;
  @Input() mSingFileIcon = '';
  @Output() readonly mCreateTask = new EventEmitter<NzUploadFile[]>();
  @Output() readonly mFileListChange = new EventEmitter<NzUploadFile[]>();
  fileList: NzUploadFile[] = [];
  constructor(protected msg: NzMessageService) {}

  beforeUpload = (file: NzUploadFile): boolean => {
    if (file.name.length > 255) {
      this.msg.error('文件名称过长，请修改后重新上传（名称应小于255字）');
      return false;
    }
    file.sizeValue = transformFileSize(file.size as number);
    this.fileList = this.fileList.concat(file);
    this.mFileListChange.emit(this.fileList);
    return false;
  };

  onCreateTask(): void {
    this.mCreateTask.emit(this.fileList);
  }

  fileListChange(files: NzUploadFile[]): void {
    this.mFileListChange.emit(files);
  }
}
